import classNames from 'classnames';
import ProjectBadge from 'components/projects/ProjectBadge';
import { Column, Item } from 'components/ui-blocks/placeholder';
import { range } from 'lodash-es';
import React, { Component } from 'react';
import type { EnrichedForecast } from 'routes/forecast/types/forecast';
import { prefixHexColor } from 'utils/colors';
import { getProjectColor } from 'utils/project';
import styles from './ProjectSuggestions.module.scss';

interface ForecastSuggestionsProps {
  suggestions: Array<EnrichedForecast>;
  onChange: (projectId: number, forecastId: number) => void;
  showPlaceholders: boolean;
  className?: string;
  size: 'large';
  /** How many suggestions do we show? */
  count?: number;
}

export class ForecastSuggestions extends Component<ForecastSuggestionsProps> {
  static defaultProps = {
    size: 'large',
    showPlaceholders: false,
    count: 4,
  };

  renderPlaceholders = () => {
    const columns = range(3).map((key, i) => {
      return <Column key={i} span={12} className={styles.placeholderOption} />;
    });
    return <Item className={styles.placeholderContainer}>{columns}</Item>;
  };

  renderSuggestions = () => {
    const { onChange, count } = this.props;
    const suggestions = this.props.suggestions.slice(0, count);

    return suggestions.map(forecast => {
      return (
        <button
          data-testid="forecast_suggestion"
          className={classNames(styles.projectOption, this.props.className)}
          type="button"
          key={forecast.id}
          onClick={() => onChange(forecast.project?.id ?? 0, forecast.id)}
        >
          <ProjectBadge
            className={styles.bullet}
            color={prefixHexColor(getProjectColor(forecast.project))}
            icon="task"
            size="small"
            ticMeta={forecast.tic}
          />

          <div className={styles.nameAndClient}>
            <span className="fs-mask">{forecast.title}</span>
            <small className="fs-mask">
              ({forecast.project?.name}, {forecast.project?.client?.name})
            </small>
          </div>
        </button>
      );
    });
  };

  render() {
    const { showPlaceholders, size } = this.props;
    return (
      <div className={classNames(styles.container, this.props.className, styles[`size-${size}`])}>
        <small>
          <i className={styles.hint}>or choose a recent task or project</i>
        </small>
        {showPlaceholders ? this.renderPlaceholders() : this.renderSuggestions()}
      </div>
    );
  }
}
